import {
  object,
  string,
  boolean,
  array,
  optional,
  type InferInput,
} from "valibot";
import { CurrencyCode } from "./CurrencyCode";
import { LanguageCode } from "./LanguageCode";

export type UserProfile = InferInput<typeof UserProfile>;
export const UserProfile = object({
  id: string(),
  name: string(),
  profileCurrency: CurrencyCode,
  isKilometers: boolean(),
  profileLanguage: LanguageCode,
  optedInMarketingEmails: boolean(),
  is24h: boolean(),
  emails: optional(
    array(
      object({
        email: string(),
        isPrimary: boolean(),
      }),
    ),
  ),
});
